import Vue from 'vue'
import App from './views/Index.vue'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import './assets/css/app.css'
import './assets/css/bootstrap.min.css'
import './assets/css/carousel.css'
import './assets/css/down_app.css'
import './assets/css/list-deta.css'
import './assets/css/list.css'



Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
